import * as React from 'react';
import { Dispatch } from 'redux';
import { CreateEventRequest, EventViewModel, SnapcodeViewModel } from 'stageclip-common';

import { BaseApiPatchRequest } from '../generic/baseApiPatchRequest';
import * as EntityNormalizers from '../normalizers/entityNormalizers';
import * as EventNormalizers from '../normalizers/eventNormalizers';

import { toFormData, appendAsJSONFile } from 'helpers/requestHelper';

export class EditEventRequest extends BaseApiPatchRequest<
  EventViewModel,
  EntityNormalizers.NormalizedSingleEntity<EventNormalizers.NormalizedEvents>
> {
  constructor(
    eventId: string,
    createEventFormData: CreateEventRequest,
    component: React.Component,
    dispatch: Dispatch,
  ) {
    super(createEventFormData, component, dispatch);
    this.path = `/events/${eventId}`;
    this.normalizeMethod = EventNormalizers.normalizeEvent;
  }

  protected generateRequest() {
    const request = super.generateRequest();
    const { clipConfiguration, ...requestBody } = this.body;

    // Remove SelfClipReminder emails as they are not supported in edit event and will cause the request to fail
    requestBody.emails = Object.keys(requestBody.emails || {}).reduce((acc: any, key) => {
      if (!key.includes('SelfClipReminder') && requestBody.emails) {
        acc[key] = requestBody.emails[key as keyof typeof requestBody.emails];
      }

      return acc;
    }, {});

    // remove snapcodes img when is a link
    if (requestBody && requestBody.snapcodes && !!requestBody.snapcodes.length) {
      const { snapcodes } = requestBody as { snapcodes: SnapcodeViewModel[] };

      requestBody.snapcodes = snapcodes.map(snapcode => ({
        ...snapcode,
        file: snapcode.file === null || typeof snapcode.file === 'string' ? undefined : snapcode.file,
      }));
    }

    request.body = toFormData(requestBody);
    appendAsJSONFile(request.body, 'clipConfiguration', clipConfiguration);

    return request;
  }

  protected generateHeaders() {
    const headers = super.generateHeaders();
    headers.delete('Content-type');

    return headers;
  }
}
